import { lazy } from 'react';
import { Navigate } from "react-router-dom";
import Loadable from '../shared/common/Loadable';
import NotFound from "../../features/errors/NotFound";
import ServerError from "../../features/errors/ServerError";
import Customer from "../../features/customer/Index";
import Product from "../../features/product/Index";
import Cart from "../../features/cart/Index";
import Order from "../../features/order/Index";
import RequireAuth from "./RequireAuth";
import DashboardLayout from "../layout/Dashboard";
import Checkout from "../../features/checkout/Index";
import CartDetail from "../../features/cart-detail/Index";
import OrderDetail from "../../features/order-detail/Index";
import AddCustomer from '../../features/onboarding/AddCustomer';
import AddOutlet from '../../features/onboarding/AddOutlet';
import UploadOutletAttachment from '../../features/onboarding/UploadOutletAttachment';
import UploadCustomerAttachment from '../../features/onboarding/UploadCustomerAttachment';
const CustomerDetail  = Loadable(lazy(() => import("../../features/customer/customerDetail")));
const Dashboard = Loadable(lazy(() => import('../../features/Dashboard')));
const Profile = Loadable(lazy(() => import('../../features/profile/Index')));

const AppRoutes ={
  path: "/",
  element: <RequireAuth />,
  children: [
    {
      element: <DashboardLayout />,
      children: [
        {
          path: "/",
          element: <Dashboard />
        },
        {
          path: "customer",
          children: [
            {
              index: true,
              element: <Customer />,
            },
            {
              path: "detail/:id",
              element: <CustomerDetail />,
            },
          ],
        },
        {
          path: "/create-cart/:outletId/:customerTypeId/:customerId",
          element: <Cart />
        },
        { path: "product", element: <Product /> },
        { path: "profile", element: <Profile /> },
        { path: "order", element: <Order /> },
        { path: "checkout", element: <Checkout /> },
        { path: "cartDetail", element: <CartDetail /> },
        { path: "order-detail/:orderId", element: <OrderDetail /> },
        { path: "profile", element: <Profile /> },
        {path: "customer-onboard/add", element: <AddCustomer />},
        {path: "customer-onboard/upload-attachment/:organisationId", element: <UploadCustomerAttachment />},
        {path: "outlet/add/:orgId", element: <AddOutlet />},
        {path: "outlet/upload-attachment/:outletId", element: <UploadOutletAttachment />},
        {path: "customer/update-outlet/:orgId/:outletId", element: <AddOutlet />},

      ],
    },
    { path: "not-found", element: <NotFound /> },
    { path: "server-error", element: <ServerError /> },
    { path: "*", element: <Navigate replace to="/not-found" /> },
  ],
};

export default AppRoutes;
